export const Logo = ({ className = "", markSize = 34, stacked = false, testId = "brand-logo" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={testId}>
      <svg
        width={markSize}
        height={markSize}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
        aria-hidden="true"
      >
        <path d="M24 5 L41 43" stroke="#c9a84c" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M24 5 L7 43" stroke="#c9a84c" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M24 12 L36 40" stroke="#c9a84c" strokeWidth="0.9" strokeLinecap="round" opacity="0.55" />
        <path d="M24 12 L12 40" stroke="#c9a84c" strokeWidth="0.9" strokeLinecap="round" opacity="0.55" />
        <path d="M15 30 L33 30" stroke="#c9a84c" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
      <div className={`flex ${stacked ? "flex-col leading-none" : "flex-col leading-none"}`}>
        <span className="font-display text-[#e8d9a8] tracking-tight text-lg font-medium leading-none">
          The Accountant
        </span>
        <span className="font-body text-[#c9a84c] text-[9px] tracking-[0.42em] uppercase mt-1 leading-none">
          Pty&nbsp;Ltd
        </span>
      </div>
    </div>
  );
};
